module.exports = __webpack_public_path__ + "img/y- (1).9e81482f.jpg";